/**
 * Garantia status display component
 */
import React from 'react';
import { Label } from '../ui/label';

const GarantiaDisplay = ({ label, value, calculando, testId }) => {
  const getClassName = () => {
    if (calculando) {
      return 'bg-gray-100 text-gray-600 border border-gray-300';
    }
    if (value === 'Vigente') {
      return 'bg-green-100 text-green-800 border border-green-300';
    }
    if (value === 'Vencido') {
      return 'bg-red-100 text-red-800 border border-red-300';
    }
    return 'bg-yellow-100 text-yellow-800 border border-yellow-300';
  };

  return (
    <div>
      <Label className="text-xs sm:text-sm">{label}</Label>
      <div 
        data-testid={testId}
        className={`mt-1 px-3 py-2 rounded-md text-sm font-medium text-center flex items-center justify-center gap-2 ${getClassName()}`}
      >
        {calculando ? (
          <>
            <svg className="animate-spin h-4 w-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
              <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
              <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
            Calculando...
          </>
        ) : (
          value || 'No Identificado'
        )}
      </div>
    </div>
  );
};

export default GarantiaDisplay;
